import ContentLoader from 'react-content-loader';
import type { VoidFunctionComponent } from 'react';

import COLORS from '../../../../../theme/colors';

/**
 * Loading component for the file view.
 */
const CodeMirrorLoader: VoidFunctionComponent = () => (
  <div className="padding-top-xs padding-bottom-xs">
    <ContentLoader
      speed={2}
      width={300}
      height={750}
      viewBox="0 0 300 750"
      backgroundColor={COLORS.fossaGray05}
      foregroundColor={COLORS.fossaGray10}
    >
      {/* Line numbers column */}
      <rect x="4" y="0" rx="2" ry="2" width="20" height="12" />
      <rect x="4" y="18" rx="2" ry="2" width="20" height="12" />
      <rect x="4" y="36" rx="2" ry="2" width="20" height="12" />
      <rect x="4" y="54" rx="2" ry="2" width="20" height="12" />
      <rect x="4" y="72" rx="2" ry="2" width="20" height="12" />
      <rect x="4" y="90" rx="2" ry="2" width="20" height="12" />
      <rect x="4" y="108" rx="2" ry="2" width="20" height="12" />
      <rect x="4" y="126" rx="2" ry="2" width="20" height="12" />
      <rect x="4" y="144" rx="2" ry="2" width="20" height="12" />
      <rect x="4" y="162" rx="2" ry="2" width="20" height="12" />
      <rect x="4" y="180" rx="2" ry="2" width="20" height="12" />
      <rect x="4" y="198" rx="2" ry="2" width="20" height="12" />
      <rect x="4" y="216" rx="2" ry="2" width="20" height="12" />
      <rect x="4" y="234" rx="2" ry="2" width="20" height="12" />
      <rect x="4" y="252" rx="2" ry="2" width="20" height="12" />
      <rect x="4" y="270" rx="2" ry="2" width="20" height="12" />
      <rect x="4" y="288" rx="2" ry="2" width="20" height="12" />
      <rect x="4" y="306" rx="2" ry="2" width="20" height="12" />
      <rect x="4" y="324" rx="2" ry="2" width="20" height="12" />
      <rect x="4" y="342" rx="2" ry="2" width="20" height="12" />

      {/* Code lines with varying lengths and indentation */}
      <rect x="32" y="0" rx="2" ry="2" width="130" height="12" />
      <rect x="32" y="18" rx="2" ry="2" width="190" height="12" />
      <rect x="32" y="36" rx="2" ry="2" width="160" height="12" />
      <rect x="32" y="54" rx="2" ry="2" width="0" height="12" /> {/* Empty line */}
      <rect x="32" y="72" rx="2" ry="2" width="210" height="12" />
      <rect x="48" y="90" rx="2" ry="2" width="180" height="12" /> {/* Indented */}
      <rect x="32" y="108" rx="2" ry="2" width="0" height="12" /> {/* Empty line */}
      <rect x="32" y="126" rx="2" ry="2" width="150" height="12" />
      <rect x="48" y="144" rx="2" ry="2" width="200" height="12" /> {/* Indented */}
      <rect x="64" y="162" rx="2" ry="2" width="140" height="12" /> {/* Double indented */}
      <rect x="64" y="180" rx="2" ry="2" width="170" height="12" /> {/* Double indented */}
      <rect x="48" y="198" rx="2" ry="2" width="120" height="12" /> {/* Indented */}
      <rect x="32" y="216" rx="2" ry="2" width="185" height="12" />
      <rect x="32" y="234" rx="2" ry="2" width="0" height="12" /> {/* Empty line */}
      <rect x="32" y="252" rx="2" ry="2" width="165" height="12" />
      <rect x="48" y="270" rx="2" ry="2" width="195" height="12" /> {/* Indented */}
      <rect x="64" y="288" rx="2" ry="2" width="150" height="12" /> {/* Double indented */}
      <rect x="64" y="306" rx="2" ry="2" width="110" height="12" /> {/* Double indented */}
      <rect x="48" y="324" rx="2" ry="2" width="100" height="12" /> {/* Indented */}
      <rect x="32" y="342" rx="2" ry="2" width="135" height="12" />

      {/* Additional lines to fill the height */}
      <rect x="4" y="368" rx="2" ry="2" width="20" height="12" />
      <rect x="32" y="368" rx="2" ry="2" width="175" height="12" />
      <rect x="4" y="386" rx="2" ry="2" width="20" height="12" />
      <rect x="48" y="386" rx="2" ry="2" width="155" height="12" />
      <rect x="4" y="404" rx="2" ry="2" width="20" height="12" />
      <rect x="64" y="404" rx="2" ry="2" width="130" height="12" />
      <rect x="4" y="422" rx="2" ry="2" width="20" height="12" />
      <rect x="32" y="422" rx="2" ry="2" width="190" height="12" />
      <rect x="4" y="440" rx="2" ry="2" width="20" height="12" />
      <rect x="32" y="440" rx="2" ry="2" width="0" height="12" />
      <rect x="4" y="458" rx="2" ry="2" width="20" height="12" />
      <rect x="32" y="458" rx="2" ry="2" width="160" height="12" />
      <rect x="4" y="476" rx="2" ry="2" width="20" height="12" />
      <rect x="48" y="476" rx="2" ry="2" width="185" height="12" />
      <rect x="4" y="494" rx="2" ry="2" width="20" height="12" />
      <rect x="64" y="494" rx="2" ry="2" width="145" height="12" />
      <rect x="4" y="512" rx="2" ry="2" width="20" height="12" />
      <rect x="48" y="512" rx="2" ry="2" width="135" height="12" />
      <rect x="4" y="530" rx="2" ry="2" width="20" height="12" />
      <rect x="32" y="530" rx="2" ry="2" width="170" height="12" />
      <rect x="4" y="548" rx="2" ry="2" width="20" height="12" />
      <rect x="32" y="548" rx="2" ry="2" width="0" height="12" />
      <rect x="4" y="566" rx="2" ry="2" width="20" height="12" />
      <rect x="32" y="566" rx="2" ry="2" width="205" height="12" />
      <rect x="4" y="584" rx="2" ry="2" width="20" height="12" />
      <rect x="48" y="584" rx="2" ry="2" width="150" height="12" />
      <rect x="4" y="602" rx="2" ry="2" width="20" height="12" />
      <rect x="64" y="602" rx="2" ry="2" width="180" height="12" />
      <rect x="4" y="620" rx="2" ry="2" width="20" height="12" />
      <rect x="48" y="620" rx="2" ry="2" width="125" height="12" />
      <rect x="4" y="638" rx="2" ry="2" width="20" height="12" />
      <rect x="32" y="638" rx="2" ry="2" width="165" height="12" />
      <rect x="4" y="656" rx="2" ry="2" width="20" height="12" />
      <rect x="32" y="656" rx="2" ry="2" width="140" height="12" />
      <rect x="4" y="674" rx="2" ry="2" width="20" height="12" />
      <rect x="32" y="674" rx="2" ry="2" width="195" height="12" />
      <rect x="4" y="692" rx="2" ry="2" width="20" height="12" />
      <rect x="48" y="692" rx="2" ry="2" width="135" height="12" />
      <rect x="4" y="710" rx="2" ry="2" width="20" height="12" />
      <rect x="32" y="710" rx="2" ry="2" width="175" height="12" />
      <rect x="4" y="728" rx="2" ry="2" width="20" height="12" />
      <rect x="48" y="728" rx="2" ry="2" width="160" height="12" />
      <rect x="4" y="746" rx="2" ry="2" width="20" height="12" />
      <rect x="32" y="746" rx="2" ry="2" width="190" height="12" />
      <rect x="4" y="764" rx="2" ry="2" width="20" height="12" />
      <rect x="48" y="764" rx="2" ry="2" width="145" height="12" />
      <rect x="4" y="782" rx="2" ry="2" width="20" height="12" />
      <rect x="32" y="782" rx="2" ry="2" width="170" height="12" />
    </ContentLoader>
  </div>
);

export default CodeMirrorLoader;
